import {
    createSelector,
    createEntityAdapter
} from "@reduxjs/toolkit";
import { apiSlice } from "../../app/api/apiSlice"

const actionsAdapter = createEntityAdapter({
    sortComparer: (a, b) => (a.completed === b.completed) ? 0 : a.completed ? 1 : -1
})

const initialState = actionsAdapter.getInitialState()

export const actionsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getActions: builder.query({
            query: () => ({
                url: '/api/actions',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            transformResponse: responseData => {
                const loadedActions = responseData.map(action => {
                    action.id = action._id
                    return action
                });
                return actionsAdapter.setAll(initialState, loadedActions)
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'Action', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'Action', id }))
                    ]
                } else return [{ type: 'Action', id: 'LIST' }]
            }
        }),
        getGrades: builder.query({
            query: () => ({
                url: '/api/actions/my-grades',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
            providesTags: ['UserGradeList'],
        }),

        addNewAction: builder.mutation({
            query: initialAction => ({
                url: '/api/actions',
                method: 'POST',
                body: {
                    ...initialAction,
                }
            }),
            invalidatesTags: [
                { type: 'Action', id: "LIST" }
            ]
        }),
        updateAction: builder.mutation({
            query: initialAction => ({
                url: '/api/actions',
                method: 'PATCH',
                body: {
                    ...initialAction,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Action', id: arg.id }
            ]
        }),
        deleteAction: builder.mutation({
            query: ({ id }) => ({
                url: `/api/actions`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'Action', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetActionsQuery,
    useGetGradesQuery,
    useAddNewActionMutation,
    useUpdateActionMutation,
    useDeleteActionMutation,
} = actionsApiSlice

// returns the query result object
export const selectActionsResult = actionsApiSlice.endpoints.getActions.select()

// creates memoized selector
const selectActionsData = createSelector(
    selectActionsResult,
    actionsResult => actionsResult.data // normalized state object with ids & entities
)


//getSelectors creates these selectors and we rename them with aliases using destructuring
export const {
    selectAll: selectAllActions,
    selectById: selectActionById,
    selectIds: selectActionIds
    // Pass in a selector that returns the actions slice of state
} = actionsAdapter.getSelectors(state => selectActionsData(state) ?? initialState)